import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, TitleStrategy } from '@angular/router';
import { initializeApp } from 'firebase/app';
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { ActivityLogService } from './core/services/activity-log.service';
import { CustomTitleStrategy } from './core/services/title-strategy.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
    provideAppInitializer(async () => {
      // アプリケーション起動時にFirebaseを初期化
      initializeApp(environment.firebaseConfig);

      // ActivityLogServiceを初期化
      inject(ActivityLogService).init();

      // Chart.js のグローバルプラグインを登録
      Chart.register(...registerables, annotationPlugin);

      // Google Maps JavaScript API を動的にロード
      // ロード失敗時もアプリ起動を継続させるため try-catch でラップ
      try {
        setOptions({ key: environment.googleMapsApiKey, v: 'weekly' });
        await Promise.all([
          importLibrary('maps'),
          importLibrary('marker'),
          importLibrary('geocoding'),
        ]);
      } catch (error) {
        console.error('Google Maps API のロードに失敗しました。地図機能は利用できません。', error);
      }
    }),
  ],
};
